module.exports = __webpack_public_path__ + "static/img/areaA_7.9e1d705.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA_7.png
// module id = 980
// module chunks = 1